import { Manage } from '@features/Unsubscribe';
const ManageSubscription = () => <Manage data-sentry-element="Manage" data-sentry-component="ManageSubscription" data-sentry-source-file="index.tsx" />;
export default ManageSubscription;